(ns heraldicon.shared
  (:require
   ["paper" :as paper]
   [heraldicon.entity.charge.data]
   [heraldicon.entity.collection.data]
   [heraldicon.entity.collection.element]
   [heraldicon.entity.core]
   [heraldicon.heraldry.achievement]
   [heraldicon.heraldry.charge-group.core]
   [heraldicon.heraldry.charge-group.options]
   [heraldicon.heraldry.charge.core]
   [heraldicon.heraldry.charge.options]
   [heraldicon.heraldry.charge.other]
   [heraldicon.heraldry.charge.render]
   [heraldicon.heraldry.coat-of-arms]
   [heraldicon.heraldry.cottising]
   [heraldicon.heraldry.field.core]
   [heraldicon.heraldry.field.render]
   [heraldicon.heraldry.helms]
   [heraldicon.heraldry.motto]
   [heraldicon.heraldry.option.attributes]
   [heraldicon.heraldry.ordinary.core]
   [heraldicon.heraldry.ordinary.options]
   [heraldicon.heraldry.ordinary.render]
   [heraldicon.heraldry.ornaments]
   [heraldicon.heraldry.ribbon]
   [heraldicon.heraldry.semy]
   [heraldicon.heraldry.subfield]
   [heraldicon.heraldry.tincture]
   [heraldicon.render.shared]))

(.setup paper (paper/Size. 500 500))
